import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4649c20b")

_pushScopeId("data-v-4649c20b")
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "page login__fullpage" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "Login", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Email Address")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Password")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Login")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Forgot Password? ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Reset Login")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Not a Member? ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Sign up")
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "ion-margin-top"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Google")
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Apple")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _hoisted_2
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", {
            class: "login__fullbackground",
            style: { 'background-image': `url(${_ctx.client.home_banner_image})` }
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_ion_grid, { class: "login__grid" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, { class: "login__row" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withId(() => [
                          _createVNode(_component_ion_card, {
                            class: "category-card login__container",
                            color: "light"
                          }, {
                            default: _withId(() => [
                              (
											_ctx.client.dark_logo &&
											_ctx.client.light_logo &&
											_ctx.client.mode === 'dark'
										)
                                ? (_openBlock(), _createBlock(_component_ion_img, {
                                    key: 0,
                                    src: _ctx.client.light_logo,
                                    style: {"max-width":"250px","margin":"0 auto"}
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (
											_ctx.client.dark_logo &&
											_ctx.client.light_logo &&
											_ctx.client.mode !== 'dark'
										)
                                ? (_openBlock(), _createBlock(_component_ion_img, {
                                    key: 1,
                                    src: _ctx.client.dark_logo,
                                    style: {"max-width":"250px","margin":"0 auto"}
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              _hoisted_4,
                              _hoisted_5,
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withId(() => [
                                  _hoisted_6
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                style: {"border":"1px solid #fff"},
                                autocomplete: "off",
                                type: "email",
                                modelValue: _ctx.email,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                                value: _ctx.email,
                                onIonInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event.target.value))
                              }, null, 8, ["modelValue", "value"]),
                              _hoisted_7,
                              _createVNode(_component_ion_label, { position: "floating" }, {
                                default: _withId(() => [
                                  _hoisted_8
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_input, {
                                style: {"border":"1px solid #fff"},
                                autocomplete: "off",
                                type: "password",
                                modelValue: _ctx.password,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                                value: _ctx.password,
                                onIonInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event.target.value))
                              }, null, 8, ["modelValue", "value"]),
                              _hoisted_9,
                              _createVNode("div", _hoisted_10, [
                                _createVNode(_component_ion_button, {
                                  class: "login__base_btn",
                                  color: "primary",
                                  onClick: _cache[5] || (_cache[5] = () => _ctx.login())
                                }, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }),
                                _createVNode("p", null, [
                                  _hoisted_12,
                                  _createVNode(_component_router_link, {
                                    class: "text-dark",
                                    to: "/resetlogin"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode("p", null, [
                                  _hoisted_14,
                                  _createVNode(_component_router_link, {
                                    class: "text-dark",
                                    to: "/join",
                                    replace: ""
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_15
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _hoisted_16,
                                (_ctx.isWeb)
                                  ? (_openBlock(), _createBlock("p", _hoisted_17, "or continue with"))
                                  : _createCommentVNode("", true),
                                (!_ctx.isIOS)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 1,
                                      onClick: _cache[6] || (_cache[6] = () => _ctx.googleAuth()),
                                      class: "login__base_btn login__google_button"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.logoGoogle,
                                          class: "ion-margin-end",
                                          slot: "start"
                                        }, null, 8, ["icon"]),
                                        _hoisted_18
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _hoisted_19,
                                _hoisted_20,
                                (!_ctx.isAndroid)
                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                      key: 2,
                                      onClick: _cache[7] || (_cache[7] = () => _ctx.socialAuth('apple')),
                                      class: "login__base_btn login__apple_button"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_icon, {
                                          icon: _ctx.logoApple,
                                          class: "ion-margin-end",
                                          slot: "start"
                                        }, null, 8, ["icon"]),
                                        _hoisted_21
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ], 4)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})